module.exports = __webpack_public_path__ + "static/choose-4d0b59144d608fae2ca96d9705b6acfb.png";